module.exports = __webpack_public_path__ + "static/1352439474.4d1b5cfd.jpg";